import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import {AuthService} from '../../services/auth/auth.service';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { PermissionService } from 'src/app/services/api/permission.service';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.TENANT_READ,
    action: Permissions.TENANT_READ,
  },
  {
    key: PermissionKeys.SOLUTION_READ,
    action: Permissions.SOLUTION_READ,
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_NONPII,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_PII,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_LIVE,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.AUDIT_READ,
    action: Permissions.AUDIT_READ,
  },
  {
    key: PermissionKeys.GROUP_READ,
    action: Permissions.GROUP_READ,
  },
  {
    key: PermissionKeys.ROLE_READ,
    action: Permissions.ROLE_READ,
  }
];

@Component({
    selector: 'app-side-navigation',
    templateUrl: './left-side-navigation.component.html',
    styleUrls: ['./left-side-navigation.component.scss'],
    standalone: false
})
export class LeftSideNavigationComponent implements OnInit {

  @Input() disableSideNav: boolean;
  @Output() menuClick = new EventEmitter<boolean>();
  tenant: string;

  verticalMenuItems: any;
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean; };

  constructor(private router: Router, private authService: AuthService, public sidenavService: SidenavService, private permissionsService: PermissionsService, private permissionService: PermissionService) {
  }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
    // Loads global-level permissions (if not already set).
    if (this.authService.scope !== '/global') {
      let scope = '/global';
      this.authService.scope = scope;
      this.permissionService.getAuthAssignedPermissions(scope).pipe().subscribe(response => {
        this.authService.assignedPermissions = response.permissions;
        this.setMenuItems(); 
      });
    } else {
      this.setMenuItems()
    }
  }
  /**
   * Resolves API permissions and builds the vertical navigation menu
   * based on the user's assigned permissions.
   */
  setMenuItems(){
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.verticalMenuItems = [
      {
        nameKey: 'LEFT_SIDE_NAV.MAIN_NAVIGATION',
        items: [
          {
            nameKey: 'LEFT_SIDE_NAV.DASHBOARDS',
            icon: 'rocket',
            expanded: false,
            items: [
              // {
              //   nameKey: 'LEFT_SIDE_NAV.COST_MANAGEMENT',
              //   link: 'comingsoon',
              // },
              {
                nameKey: 'LEFT_SIDE_NAV.TENANT',
                link: 'tenants',
                permission : this.permissionsMap[PermissionKeys.TENANT_READ]
              },
              {
                nameKey: 'LEFT_SIDE_NAV.INSTANCE',
                link: 'instance',
                permission : this.permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII] || this.permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII] || this.permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_LIVE]
              },
              {
                nameKey: 'LEFT_SIDE_NAV.AUDIT_DASHBOARD',
                link: 'audit-dashboard',
                permission : this.permissionsMap[PermissionKeys.AUDIT_READ]
              },
              // {
              //   nameKey: 'LEFT_SIDE_NAV.MONITORING',
              //   link: 'comingsoon',
              // }
            ]
          },
          // {
          //   nameKey: 'LEFT_SIDE_NAV.EXTERNAL',
          //   icon: 'outbound',
          //   expanded: false,
          //   items: [
          //     {
          //       nameKey: 'LEFT_SIDE_NAV.EXTERNAL_TENANT',
          //       link: 'external-tenant',
          //     },
          //     {
          //       nameKey: 'LEFT_SIDE_NAV.EXTERNAL_INSTANCE',
          //       link: 'external-instance',
          //     }
          //   ]
          // }
        ]
      },
      {
        nameKey: 'LEFT_SIDE_NAV.ACTIONABILITY',
        items: [
          {
            nameKey: 'LEFT_SIDE_NAV.SOLUTION_ONBOARDING',
            icon: 'tips_and_updates',
            expanded: false,
            items: [
              {
                nameKey: 'LEFT_SIDE_NAV.SOLUTIONS',
                link: 'solutions',
                permission : this.permissionsMap[PermissionKeys.SOLUTION_READ]
              },
              // {
              //   nameKey: 'LEFT_SIDE_NAV.LINE_OF_BUSINESS',
              //   link: 'lob',
              // },
              {
                nameKey: 'LEFT_SIDE_NAV.COMPONENTS',
                link: 'components',
                permission : this.permissionsMap[PermissionKeys.SOLUTION_READ]
              },
            ]
          },
          {
            nameKey: 'LEFT_SIDE_NAV.TENANT_ONBOARDING',
            icon: 'account_balance',
            expanded: false,
            items: [
              {
                nameKey: 'LEFT_SIDE_NAV.TENANT_ONBOARDING_TENANT',
                link: 'tenant-onboarding',
                permission : this.permissionsMap[PermissionKeys.TENANT_READ]
              // },
              // {
              //   nameKey: 'LEFT_SIDE_NAV.SUBSCRIPTION',
              //   link: 'subscription',
              // },
              // {
              //   nameKey: 'LEFT_SIDE_NAV.EDGE_NETWORK',
              //   link: 'edge-network',
              // },
              // {
              //   nameKey: 'LEFT_SIDE_NAV.SHARED_SERVICES',
              //   link: 'shared-services',
              }
            ]
          },
          // {
          //   nameKey: 'LEFT_SIDE_NAV.CONTINUOUS_UPGRADE',
          //   icon: 'diamond',
          //   expanded: false,
          //   items: [
          //     {
          //       nameKey: 'LEFT_SIDE_NAV.SOLUTION',
          //       link: 'updates-solution',
          //     },
          //   ]
          // },
          {
            nameKey: 'LEFT_SIDE_NAV.ACCESS_MANAGEMENT',
            icon: 'key',
            expanded: false,
            items: [
              {
                nameKey: 'LEFT_SIDE_NAV.GROUPS',
                link: 'groups',
                permission : this.permissionsMap[PermissionKeys.GROUP_READ]
              },
              {
                nameKey: 'LEFT_SIDE_NAV.ROLES',
                link: 'roles',
                permission : this.permissionsMap[PermissionKeys.ROLE_READ]
              },
            ]
          },
          // {
          //   nameKey: 'LEFT_SIDE_NAV.INITIAL_SYSTEM_BUILDS',
          //   icon: 'view_kanban',
          //   expanded: false,
          //   items: [
          //     {
          //       nameKey: 'LEFT_SIDE_NAV.VIEW_REQUEST',
          //       link: 'isb',
          //     },
          //   ]
          // },
        ]
      },
      // {
      //   nameKey: 'LEFT_SIDE_NAV.SETTINGS',
      //   items: [
      //     {
      //       nameKey: 'LEFT_SIDE_NAV.APPROVALS',
      //       icon: 'turned_in_not',
      //       expanded: false,
      //       items: [
      //         {
      //           nameKey: 'LEFT_SIDE_NAV.COST_MANAGEMENT',
      //           link: 'comingsoon',
      //         },
      //         {
      //           nameKey: 'LEFT_SIDE_NAV.SUBSCRIPTION',
      //           link: 'comingsoon',
      //         },
      //       ]
      //     },
      //   ]
      // }
    ];
    // filtering menu/ menuitem based on permission
  this.verticalMenuItems = this.verticalMenuItems.map(topMenu => ({
    ...topMenu,
    items: topMenu.items.map(subMenu => ({
      ...subMenu,
      items: subMenu.items.filter(i => i.permission !== false)
    })).filter(subMenu => subMenu.items.length > 0)
  })).filter(topMenu => topMenu.items.length > 0);

  }

  menuItemClicked(item): void {
    if (item.link) {
      this.sidenavService.selectedMenu = item.nameKey;
      this.router.navigate(['/',this.authService.principal.provider, item.link]);
    }
  }
}